// Comparação de data de expiração sem moment.
//
// SubscriptionGate e TrialSubscriptionGuard são carregados em TODA visita
// (Container.jsx os importa direto, sem lazy). Como usavam moment só para
// "já passou desta data?", a biblioteca inteira — com todos os locales — ia
// parar no bundle principal por causa de duas comparações.
//
// Date nativo resolve isso sem custo de bundle. Nada aqui depende de locale:
// a formatação para exibição continua acontecendo onde já acontecia.

// `planExpirationDate` é uma DATE sem hora ("2026-08-15", ou o mesmo dia
// serializado como meia-noite UTC). Uma data sem hora vale até o FIM do dia:
// `new Date("2026-08-15")` cai na meia-noite UTC, que em Brasília é 21h do dia
// 14 — o plano era considerado vencido antes mesmo do último dia pago começar.
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
const UTC_MIDNIGHT = /^(\d{4})-(\d{2})-(\d{2})T00:00:00(\.000)?Z?$/;

const endOfLocalDay = (year, month, day) =>
  new Date(Number(year), Number(month) - 1, Number(day), 23, 59, 59, 999);

// Converte para Date aceitando o que a API costuma devolver: ISO, timestamp
// numérico (em ms ou em segundos) e Date já pronto.
export const parseExpiration = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "number") {
    // Timestamps em segundos (10 dígitos) chegam de alguns provedores de
    // pagamento; multiplicar evita interpretar 1770000000 como 1970.
    const ms = value < 1e12 ? value * 1000 : value;
    const date = new Date(ms);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const raw = String(value).trim();
  const dayOnly = raw.match(DATE_ONLY) || raw.match(UTC_MIDNIGHT);
  if (dayOnly) {
    return endOfLocalDay(dayOnly[1], dayOnly[2], dayOnly[3]);
  }
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const isExpirationValid = (value) => parseExpiration(value) !== null;

// `true` só quando a data existe E já passou. Data inválida devolve `false`
// para não bloquear o acesso de alguém por causa de um campo malformado.
export const hasExpired = (value, now = new Date()) => {
  const date = parseExpiration(value);
  if (!date) return false;
  return now.getTime() > date.getTime();
};

// Formata como DD/MM/YYYY montando campo a campo, e não por toLocaleDateString:
// esse depende dos dados de ICU do Node/navegador e pode cair no padrão
// americano, imprimindo 07/20/2026.
export const formatExpirationDate = (value, fallback = "data desconhecida") => {
  const date = parseExpiration(value);
  if (!date) return fallback;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
};
